import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CustomItem, ENVIRONMENT, Environment } from '@domains';
import { Deserialize, Serialize } from 'cerialize';

import { BaseApiService } from '../base-api.service';

@Injectable({
  providedIn: 'root',
})
export class CustomItemService extends BaseApiService<CustomItem> {
  constructor(
    @Inject(ENVIRONMENT) override config: Environment,
    override http: HttpClient,
  ) {
    super(config, http, 'custom_items', CustomItem, 'CustomItem');
  }

  override serialize(item: CustomItem) {
    return {
      ...Serialize({ ...item }, CustomItem),
    };
  }

  override deserialize(data: any): CustomItem {
    const res = new CustomItem({
      ...Deserialize(data, CustomItem),
    });
    res.setInitialValue();
    return res;
  }
}
